import { FC } from "react";
import { TransferCaseModalProps } from "./types";



const TransferCaseModal: FC<TransferCaseModalProps> = ({ isModalVisible, hideModal, uploadClinicalInfo }): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <p className="modal-title fw-bold" style={{color:'#008853', fontSize:'1.875rem'}}>
              This prescription requires a PA. MQC can help the process the PA on your behalf
              if you upload supporting clinical doucments
            </p>
            {/* <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button> */}

          </div>

          <div className="modal-body">
            <div className="d-flex justify-content-center align-items-center gap-2">
              <button type="button" onClick={uploadClinicalInfo} className="btn btn-green btn-sm">
                <i className="fas fa-prescription"></i>  Upload Clinicals
              </button>
              <button type="button" onClick={hideModal} className="btn btn-danger btn-sm">
                Not now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransferCaseModal
